export default {
  industriesTimestamp(state) {
    return state.industriesTimestamp;
  },
  industries(state) {
    return state.industries;
  },
  jobsTimestamp(state) {
    return state.jobsTimestamp;
  },
  jobs(state) {
    return state.jobs;
  },
  jobsLoading(state) {
    return state.jobsLoading;
  },
  clientsTimestamp(state) {
    return state.clientsTimestamp;
  },
  clients(state) {
    return state.clients;
  },
  rightsToWorkOptions(state) {
    return state.rightsToWorkOptions;
  },
  rightsToWorkVisaOptions(state) {
    return state.rightsToWorkVisaOptions;
  },
  standardDocumentation(state) {
    return state.standardDocumentation;
  },
};
